import { Component, Input, EventEmitter, Output, OnInit } from "@angular/core";
import { WizardSubstep } from "../../../common/wizard/wizard-subtep.interface";
import { MediaRepository } from "app/js/src/domain/media-repository";
import { UI } from "app/js/src/services/ui.service";
import { RectangleFViewModel } from "../../../common/rectangle-f/rectangle-f.view-model";
import { RectangleF } from "../../../../domain/rectangle-f";

@Component({
  selector: "icn-channel-wizard-step1-substep2",
  templateUrl: "./substep2.html",
  styleUrls: ["./substep2.scss"],
})
export class ChannelWizardStep1Substep2Component
  implements WizardSubstep, OnInit
{
  @Input() packshotUrl = "";
  @Input() placeholderImage = "";
  @Input() logoX: number;
  @Input() logoY: number;
  @Input() logoHeight: number;
  @Input() logoWidth: number;
  @Input() logoZIndex: number;
  @Input() channelId: number;
  @Output() logoXChange = new EventEmitter<number>();
  @Output() logoYChange = new EventEmitter<number>();
  @Output() logoHeightChange = new EventEmitter<number>();
  @Output() logoWidthChange = new EventEmitter<number>();
  @Output() logoZIndexChange = new EventEmitter<number>();
  @Output() packshotUrlChange = new EventEmitter<string>();
  @Output() placeholderImageChange = new EventEmitter();
  logoLeft = 0;
  logoTop = 0;
  logoRight = 0;
  logoBottom = 0;
  advanceOption = false;
  logoRectangleFVM: RectangleFViewModel;
  constructor(
    private mediaRepository: MediaRepository,
    private ui: UI,
  ) {}

  ngOnInit() {
    this._initLogoPositionControl(false);
    this.packshotUrlChange.subscribe(() => {
      this._initLogoPositionControl(true);
    });
  }

  onPackshotUrlChange(result: { url: string; isVideo: boolean }) {
    if (result.url) {
      this.mediaRepository
        .LogoUploadAnalyze(this.channelId, result.url, result.isVideo)
        .then((reponse) => {
          this.packshotUrl = result.url;
          this.onLogoLeftChange(this.fixLogoPositioningValue(reponse.Left));
          this.onLogoTopChange(this.fixLogoPositioningValue(reponse.Top));
          this.onLogoRightChange(this.fixLogoPositioningValue(reponse.Right));
          this.onLogoBottomChange(this.fixLogoPositioningValue(reponse.Bottom));
          this.packshotUrlChange.emit(result.url);
        })
        .catch(() => {
          this.PackshotUrlFailure(result.isVideo);
        });
    } else {
      this.packshotUrl = undefined;
      this.packshotUrlChange.emit(undefined);
    }
  }
  fixLogoPositioningValue(position: number): string {
    return (position * 100).toFixed(2);
  }
  PackshotUrlFailure(isVideo: boolean) {
    let message;
    if (isVideo) {
      message = `Your video logo doesn't contain alpha channel<br>Please upload an appropriate one.`;
    } else {
      message = `Failed to analyze logo`;
    }
    this.ui.notify(this.ui.EVENTS.ShowAlert, {
      title: `Logo upload error`,
      message: message,
    });
    this.packshotUrl = null;
  }

  onPlaceholderImageChange(val) {
    this.placeholderImage = val;
    this.placeholderImageChange.emit(val);
  }

  onLogoLeftChange(val) {
    this.logoLeft = val;
    if (val === null) {
      this.logoX = val;
    } else {
      this.logoX = val / 100;
      this.logoWidth = (this.logoRight - this.logoLeft) / 100;
    }
    this.logoXChange.emit(this.logoX);
    this.logoWidthChange.emit(this.logoWidth);
  }

  onLogoTopChange(val) {
    this.logoTop = val;
    if (val === null) {
      this.logoY = val;
    } else {
      this.logoY = val / 100;
      this.logoHeight = (this.logoBottom - this.logoTop) / 100;
    }
    this.logoYChange.emit(this.logoY);
  }

  onLogoRightChange(val) {
    this.logoRight = val;
    if (val === null) {
      this.logoWidth = val;
    } else {
      this.logoWidth = (this.logoRight - this.logoLeft) / 100;
    }
    this.logoWidthChange.emit(this.logoWidth);
  }

  onLogoBottomChange(val) {
    this.logoBottom = val;
    if (val === null) {
      this.logoHeight = val;
    } else {
      this.logoHeight = (this.logoBottom - this.logoTop) / 100;
    }
    this.logoHeightChange.emit(this.logoHeight);
  }

  canGoNext() {
    return true;
  }

  private _initLogoPositionControl(resetLogoPosition: boolean) {
    if (this.packshotUrl && this.packshotUrl.length > 0) {
      if (
        this.logoX != null &&
        this.logoY != null &&
        this.logoHeight != null &&
        this.logoWidth != null &&
        resetLogoPosition === false
      ) {
        this.logoLeft = this.logoX * 100;
        this.logoTop = this.logoY * 100;
        this.logoRight = this.logoLeft + this.logoWidth * 100;
        this.logoBottom = this.logoTop + this.logoHeight * 100;
        this.logoRectangleFVM = new RectangleFViewModel(
          this.logoX * 100,
          this.logoY * 100,
          this.logoHeight * 100,
          this.logoWidth * 100,
        );
      } else {
        this.logoRectangleFVM = RectangleFViewModel.fromRectangleFObject(
          RectangleF.DEFAULT,
        );
      }
      this.logoRectangleFVM.updated.subscribe((rectangleF: RectangleF) => {
        this.logoX = rectangleF.x;
        this.logoXChange.emit(rectangleF.x);

        this.logoY = rectangleF.y;
        this.logoYChange.emit(rectangleF.y);

        this.logoWidth = rectangleF.width;
        this.logoWidthChange.emit(rectangleF.width);

        this.logoHeight = rectangleF.height;
        this.logoHeightChange.emit(rectangleF.height);
      });
    } else {
      this.logoRectangleFVM = null;
    }
  }

  onLogoZIndexChange(newZIndexForLogo: number) {
    this.logoZIndexChange.emit(newZIndexForLogo);
  }
}
